"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherView = void 0;
const FeatureBasePanel_1 = require("../FeatureBasePanel");
const PromoPanelAssetConfig_1 = require("../../config/PromoPanelAssetConfig");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const PromoPanelLabelIDs_1 = require("../../enums/PromoPanelLabelIDs");
const PromoPanelTextStyles_1 = require("../../config/PromoPanelTextStyles");
const Helper_1 = require("../../utils/Helper");
const PromoPanelConfig_1 = require("../../config/PromoPanelConfig");
const PromoPanelTextLabel_1 = require("../PromoPanelTextLabel");
const CurrencyUtils_1 = require("../../utils/CurrencyUtils");
const PromoPanelButtonIDs_1 = require("../../enums/PromoPanelButtonIDs");
const Label_1 = require("@nolimitcity/slot-launcher/bin/gui/labels/Label");
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const PointerStateColorSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon");
const PromotionHandler_1 = require("@nolimitcity/slot-launcher/bin/plugins/apiplugin/freebets/PromotionHandler");
const GuiLayout_1 = require("@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout");
/**
 * Created by jonas on 2023-12-05.
 */
class VoucherView extends FeatureBasePanel_1.FeatureBasePanel {
    constructor(controller) {
        super(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NOLIMIT_VOUCHER_ICON, PromoPanelLabelIDs_1.PromoPanelLabelIDs.NOLIMIT_VOUCHER, PromoPanelTextStyles_1.PromoPanelTextStyles.FEATURE_NOLIMIT_VOUCHER_TITLE);
        this.freebetTickets = [];
        this._controller = controller;
    }
    init() {
        super.init();
        this._featureContainer = new PIXI.Container();
        this._featureContainer.name = "Voucher Container";
        this._ticketContainer = new PIXI.Container();
        this._ticketContainer.name = "_ticketContainer";
        this._featureContainer.addChild(this._ticketContainer);
        this.addChild(this._featureContainer);
        this._noPromosAvailableText = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("No promotions available at this time"));
    }
    show() {
        super.show();
    }
    hide() {
        super.hide();
    }
    onResize() {
        if (this._isOpen) {
            super.onResize();
            const bounds = NolimitApplication_1.NolimitApplication.screenBounds;
            const landscapeLayout = NolimitApplication_1.NolimitApplication.isLandscape && Helper_1.Helper.isDefaultScreenRatio(bounds);
            let availableWidth = bounds.width;
            const newScrollRect = new PIXI.Rectangle(PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, 0, bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - 1);
            if (landscapeLayout) {
                availableWidth = bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
                this._featureContainer.y = 162;
            }
            else if (NolimitApplication_1.NolimitApplication.isLandscape && !Helper_1.Helper.isDefaultScreenRatio(bounds)) {
                availableWidth = bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
                this._featureContainer.y = 300;
            }
            else {
                const topBarHeight = ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.TOP_BAR).height - 10;
                newScrollRect.width = availableWidth;
                newScrollRect.height = bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - topBarHeight - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
                newScrollRect.x = 0;
                newScrollRect.y = topBarHeight;
                this._featureContainer.y = 300;
            }
            //Local content
            this._ticketContainer.position.set(availableWidth * 0.5 - this._ticketContainer.width * 0.5, 0);
            this.position.set(0, 0);
        }
    }
    open() {
        super.open();
        this.updatePromos();
        this.onResize();
    }
    updatePromos() {
        this._ticketContainer.removeChildren();
        this.freebetTickets = [];
        const promoData = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.promotionHandler.promotionData;
        if (promoData.size > 0) {
            promoData.forEach((value, key) => {
                const ticket = this.createTicket(value);
                this.freebetTickets.push(ticket);
                this._ticketContainer.addChild(ticket);
            });
            GuiLayout_1.GuiLayout.align(this.freebetTickets, -3, GuiLayout_1.Align.LEFT, GuiLayout_1.Direction.VERTICAL);
            //this._scroll.updateContent();
        }
        else {
            this._ticketContainer.addChild(this._noPromosAvailableText);
        }
    }
    createTicket(data) {
        var _a;
        const container = new PIXI.Container();
        const ticketGfx = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.VOUCHER_TICKET));
        container.addChild(ticketGfx);
        let totalValue = 0;
        let imageName = "NORMAL";
        let imagePlacement = 0;
        if ((0, PromotionHandler_1.isNolimitBonusPromoData)(data)) {
            //NolimitBonusPromoData
            imageName = data.featureName;
            imagePlacement = 0.5;
            totalValue = data.totalAmount;
        }
        else {
            //PromoData
            let headerString = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("FREE BETS");
            const headerLabel = new Label_1.Label(headerString, PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_PRICE_STYLE);
            headerLabel.anchor.set(0.5, 0);
            headerLabel.position.set(460, 14);
            let spinsToGoText = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("#spinstogo out of #spinsleft spins to go");
            spinsToGoText = spinsToGoText.replace("#spinstogo", "" + data.count);
            spinsToGoText = spinsToGoText.replace("#spinsleft", "" + (data.count + data.used));
            const spinToGoLabel = new Label_1.Label(spinsToGoText, PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_COST_TEXT);
            spinToGoLabel.anchor.set(0.5, 0);
            spinToGoLabel.position.set(460, 200);
            container.addChild(headerLabel, spinToGoLabel);
            totalValue = data.rounds * parseFloat(data.amount);
        }
        let featureImg;
        if (imageName == "NORMAL") {
            featureImg = new PIXI.Sprite(NolimitPromotionPlugin_1.NolimitPromotionPlugin.imgLoader.getImgTexture("AS_GAME_LOGO"));
            featureImg.anchor.set(0.5, 0.5);
            featureImg.width = 390;
            featureImg.height = 130;
            const scale = Math.min(featureImg.scale.x, featureImg.scale.y);
            featureImg.scale.set(scale, scale);
            featureImg.position.set(460, 125);
        }
        else {
            featureImg = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(imageName));
            featureImg.height = 250;
            featureImg.scale.set(featureImg.scale.y, featureImg.scale.y);
            featureImg.position.set(235, 0);
        }
        container.addChild(featureImg);
        const btnCont = new PIXI.Container();
        if (this._controller.promotionPlugin.hasActionSpin() && !(0, PromotionHandler_1.isNolimitBonusPromoData)(data)) {
            const playInGameButton = this.createButton(data, false, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("In Game"));
            const playInAs = this.createButton(data, true, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("In Action Spins"));
            const separator = new PIXI.Sprite(PIXI.Texture.WHITE);
            playInGameButton.position.set(-168, 0);
            playInAs.position.set(168, 0);
            separator.anchor.set(0.5, 0.5);
            //separator.tint = PIXI.utils.string2hex("#34683c");
            separator.alpha = 0.8;
            separator.height = 90;
            separator.width = 2;
            separator.position.set(0, Math.floor(playInGameButton.height * 0.5));
            btnCont.addChild(playInGameButton, separator, playInAs);
        }
        else {
            const playInGameButton = this.createButton(data);
            btnCont.addChild(playInGameButton);
        }
        const posx = Math.floor(ticketGfx.width * 0.5);
        btnCont.position.set(posx, 265);
        container.addChild(btnCont);
        const valueLabels = this.createValueLabels(CurrencyUtils_1.CurrencyUtils.formatWithDecimalCutOff(totalValue));
        valueLabels.position.set(125, 75);
        container.addChild(valueLabels);
        const date = ((_a = data.dates) === null || _a === void 0 ? void 0 : _a.EVICT_DATE) || "";
        const endDateLabels = this.createEndDateLabels(date);
        endDateLabels.position.set(125, 182);
        container.addChild(endDateLabels);
        return container;
    }
    createButton(data, isAsButton = false, headerString) {
        var _a;
        const buttonContainer = new PIXI.Container();
        let buttonText = data.promoName === ((_a = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.promotionHandler.activePromotion) === null || _a === void 0 ? void 0 : _a.promoName) ? "CONTINUE" : "START";
        buttonText = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(buttonText);
        const colors = new PointerStateColorSet_1.PointerStateColorSet(0xffffffff);
        const buyButtonTexture = isAsButton ? ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.ACTION_SPINS_BUY_BTN) : ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.VOUCHER_START_BTN);
        let onIcons1 = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(buyButtonTexture));
        const button = new IconToggleButton_1.IconToggleButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.BUY, onIcons1, colors);
        if (isAsButton) {
            button.addClickCallback(() => {
                NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.promotionHandler.startPromoInActionSpins(data.promoName);
            });
        }
        else {
            button.addClickCallback(() => {
                NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.promotionHandler.startPromoInGame(data.promoName);
            });
        }
        button.toggled = false;
        button.enable(true);
        const buttonLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel(buttonText, PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_BUY_TEXT, {
            landscapeMaxWidth: button.width - 30,
            portraitMaxWidth: button.width - 30
        });
        buttonLabel.onResize();
        buttonLabel.position.set(button.width * 0.5, 38);
        buttonLabel.anchor.set(0.5, 0.5);
        button.addChild(buttonLabel);
        buttonContainer.addChild(button);
        if (headerString != undefined) {
            const headerLabel = new Label_1.Label(headerString);
            buttonContainer.addChild(headerLabel);
            GuiLayout_1.GuiLayout.align([button, headerLabel], 0, GuiLayout_1.Align.CENTER, GuiLayout_1.Direction.VERTICAL);
        }
        buttonContainer.pivot.set(Math.floor(buttonContainer.width * 0.5), 0);
        return buttonContainer;
    }
    createEndDateLabels(date) {
        const container = new PIXI.Container();
        const labels = new PIXI.Container();
        const headerLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("Promotion expires"), PromoPanelTextStyles_1.PromoPanelTextStyles.FREE_BETS_END_DATE, { landscapeMaxWidth: 205, portraitMaxWidth: 205 });
        headerLabel.anchor.set(0.5, 0);
        headerLabel.onResize();
        labels.addChild(headerLabel);
        const valueLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel(date, PromoPanelTextStyles_1.PromoPanelTextStyles.FREE_BETS_END_DATE, {
            landscapeMaxWidth: 205,
            portraitMaxWidth: 205
        });
        valueLabel.anchor.set(0.5, 0);
        valueLabel.position.set(0, headerLabel.height + 5);
        container.addChild(labels);
        container.addChild(valueLabel);
        return container;
    }
    createValueLabels(totalValue) {
        const container = new PIXI.Container();
        const labels = new PIXI.Container();
        const headerLabel = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.TICKET_VALUE), PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_COST_TEXT);
        labels.addChild(headerLabel);
        labels.pivot.set(labels.width * 0.5, 0);
        const valueLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel(totalValue, PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_PRICE_STYLE, {
            landscapeMaxWidth: 190,
            portraitMaxWidth: 190
        });
        valueLabel.anchor.set(0.5, 0);
        valueLabel.position.set(0, headerLabel.height + 5);
        container.addChild(labels);
        container.addChild(valueLabel);
        return container;
    }
}
exports.VoucherView = VoucherView;
//# sourceMappingURL=VoucherView.js.map